// src/hooks/useDelayedReveal.ts — PROJECT-REALCHANGE.md §3
// + permanencia ACUMULATIVA entre recargas (rc_unlock_started_at)
// + parámetro de revisión ?rc=unlock (QA interno EC)
import { useState, useEffect } from 'react';

// VITE_DELAY_OVERRIDE solo para pruebas en dev; en producción queda 930s.
const DELAY_SECONDS = Number(import.meta.env.VITE_DELAY_OVERRIDE ?? 930);
const STORAGE_KEY = 'rc_content_unlocked';
const STARTED_KEY = 'rc_unlock_started_at';

function initialUnlocked(): boolean {
  if (new URLSearchParams(window.location.search).get('rc') === 'unlock') {
    localStorage.setItem(STORAGE_KEY, 'true');
  }
  return localStorage.getItem(STORAGE_KEY) === 'true';
}

export function useDelayedReveal() {
  const [unlocked, setUnlocked] = useState(initialUnlocked);

  useEffect(() => {
    if (unlocked) return;

    // El inicio persiste entre recargas: el visitante acumula permanencia
    // hasta los 930s totales (una recarga ya no reinicia el conteo).
    const now = Date.now();
    let started = Number(localStorage.getItem(STARTED_KEY));
    if (!started || Number.isNaN(started) || started > now) {
      started = now;
      localStorage.setItem(STARTED_KEY, String(started));
    }

    const remaining = Math.max(0, DELAY_SECONDS * 1000 - (now - started));
    const timer = setTimeout(() => {
      localStorage.setItem(STORAGE_KEY, 'true');
      setUnlocked(true);
    }, remaining);
    return () => clearTimeout(timer);
  }, [unlocked]);

  return unlocked;
}
